exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Layout__root--hXdm-{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}@media (min-width:768px){.Layout__root--hXdm-{padding:54px 40px}}@media (min-width:1440px){.Layout__root--hXdm-{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.Layout__sidebar--KClvl{width:350px}@media (max-width:1024px){.Layout__sidebar--KClvl{display:none}}.Layout__main--2G1WR{width:100%}@media (min-width:1025px){.Layout__main--2G1WR{margin-left:40px;max-width:calc(100% - 350px - 40px)}}@media (min-width:1440px){.Layout__main--2G1WR{max-width:930px}}", ""]);

// exports
exports.locals = {
	"root": "Layout__root--hXdm-",
	"sidebar": "Layout__sidebar--KClvl",
	"main": "Layout__main--2G1WR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/components/Library/Layout/Layout.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/components/Library/Layout/Layout.css
// module chunks = 1